<div *ngIf="existingbookingEmailFTR" class="searchdiv">
    <div class="card screen-wrapper">
      <div class="header headerdiv">
        <h1 class="screen-title">{{ screentitle }}</h1>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-div">
              <div class="row">
                <div class="m-portlet">
                  <div style="padding: 2% 4% 2% 2%">
                    <div>
                      <div>
                        <div class="instruct">
                          <div class="int1" style="margin-left: 17px">
                            <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                            <br />
                            <span class="txt">
                              1. Select atleast one value out of INTERMILES Number,Airline PNR,Booking Reference No,
                              Ticket No,First Name,Last Name,Booking Status.
                            </span>
                            <br />
                            <span class="txt">
                              2. If using date range enter both 'From' and 'To' booking date
                            </span>
                            <br />
                          <span class="txt">
                            3. Please enter a 9-digit IM Number, or an 11-digit Number with `00` prefixed to the 9-digit IM Number.
                          </span>
                            <br />
                            <span></span>
                          </div>
                        </div>
  
                        <div class="col-md-3">
                          <label>INTERMILES Number </label>
                          <input [(ngModel)]="ftr_email_details.jp_number" maxlength="11" type="text"
                            class="form-control m-input" placeholder="Enter INTERMILES Number"
                            (input)="jpNumberValidation();isEmpty()" (blur)="jpNumberValidation1()"
                            (keypress)='keypresshandler($event)' />
                          <span id="JpErr"></span>
                        </div>
  
                        <div class="col-md-3">
                          <label class="">Airline PNR</label>
                          <input [(ngModel)]="ftr_email_details.airlinepnr" type="text" class="form-control m-input"
                            placeholder="Enter Airline PNR" (blur)="pnrValidation1()" (input)="pnrValidation();isEmpty()"
                            maxlength="6" style="text-transform: uppercase" />
                          <span id="pnrNO"></span>
                        </div>
  
                        <div class="col-md-3">
                          <label class="">Booking Reference No </label>
                          <input [(ngModel)]="ftr_email_details.order_id" type="text" class="form-control m-input"
                            placeholder="Enter Booking Reference No" (input)="orderValidation();isEmpty()"
                            (blur)="orderValidation1()" style="text-transform: uppercase" maxlength="18" />
                          <span id="orErr"></span>
                        </div>
  
  
                        <div class="clr"></div>
                        <div class="divider"></div>
                        <div class="col-md-3">
                          <label class="">Ticket No </label>
                          <input [(ngModel)]="ftr_email_details.Ticket_No" (input)="isEmpty()" type="text"
                            class="form-control m-input" placeholder="Enter Ticket No" maxlength="15" />
                          <span id="orErr"></span>
                        </div>
                        <div class="col-md-3">
                          <label class="">First Name</label>
  
                          <input [(ngModel)]="ftr_email_details.first_name" (input)="isEmpty()" type="text"
                            class="form-control m-input" placeholder="Enter First Name" (keyup)="fnameValidation();" />
                          <span id="fnErr"></span>
                        </div>
                        <div class="col-md-3">
                          <label class="">Last Name</label>
                          <input [(ngModel)]="ftr_email_details.last_name" (input)="isEmpty()" type="text"
                            class="form-control m-input" placeholder="Enter Last Name" (keyup)="lnameValidation();" />
                          <span id="lnErr"></span>
                        </div>
                        <div class="clr"></div>
                        <div class="divider"></div>
                        <div class="col-md-3">
                          <label class="">Email Status</label>
                          <select class="form-control m-input" (change)="isEmpty()"
                            [(ngModel)]="ftr_email_details.status">
                            <option value="all" disabled>Select</option>
                            <option value="all">All</option>
  
                            <option *ngFor="let item of email_status" value="{{ item.key }}">{{ item.value }}
                            </option>
                          </select>
                        </div>
  
                        <div class="col-md-3" style="margin-top: 19px">
                          <mat-form-field>
                            <input id="did" #input3 matInput [(ngModel)]="ftr_email_details.bookingdate_from"
                              [matDatepicker]="pickerFrom1" (dateChange)="toggleDisable2();incresedate();isEmpty();"
                              [disabled]="bookingdate" autocomplete="off" placeholder="From Booking Date"
                              [max]="ftr_myDate" readonly />
                            <mat-datepicker-toggle matSuffix [for]="pickerFrom1"></mat-datepicker-toggle>
                            <mat-datepicker #pickerFrom1></mat-datepicker>
                          </mat-form-field>
  
                          <button type="button" class="close opa" (click)="reset('reset3');checkStatus1();checkempty()"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <br>
  
                        </div>
  
                        <div class="col-md-3" style="margin-top: 19px">
  
                          <mat-form-field>
                            <input [min]="final" #input4 matInput [disabled]="bookingdate"
                              [(ngModel)]="ftr_email_details.bookingdate_to" [matDatepicker]="pickerTO"
                              (dateChange)="isEmpty();" autocomplete="off" [max]="ftr_newDate"
                              placeholder="To Booking Date" readonly />
                            <mat-datepicker-toggle matSuffix [for]="pickerTO"></mat-datepicker-toggle>
                            <mat-datepicker #pickerTO></mat-datepicker>
                          </mat-form-field>
                          <button type="button" class="close opa" (click)="reset('reset4');checkStatus1();"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <br>
                          <span *ngIf="invaliddate" style="color: red;font-size: 10px"> 'To' date should be greater than
                            'Form'
                            date </span>
                        </div>
                        <!-- Departure date added start Akshay -->
                        <div class="clr"></div>
                        <div class="divider"></div>
                        
                      </div>
                    </div>
                  </div>
                  <div class="clr"></div>
                  <div class="sdiv" style="margin-top: 20px;margin-right: 10px;">
                    <label class=""> Accrual</label>
                    <input type="radio" value="A" name="type" checked (click)="selectTypeOfRedemption('A')">
                    <label class=""> Redemption</label>
                    <input type="radio" value="R" name="type"  (click)="selectTypeOfRedemption('R')">
                  </div>
                  <div class="sdiv">
                    <div class="btn clear-button button-margin">
                      <button class="btn btn-primary  commonbutt" [disabled]="IsEmptyVal == false" (click)="searchData(1);"
                        type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                      <button class="btn btn-primary  commonbutt" type="button" (click)="getReprt()"
                        [disabled]="IsEmptyVal == false">
                        Download
                      </button>
                    </div>
                  </div>
                  <div class="errwrap">
                    <div class="errdiv1" id="err"></div>
                  </div>
                  <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list != '' || search_detail_list != 0"
                    [hidden]="searchlist">
                    <table aria-describedby="ftrBookingDetails" class="table table-striped" *ngIf="!loader"
                      [mfData]="serachtabledata" [mfRowsOnPage]="5">
                      <thead>
                        <tr>
                          <th scope="col" style="width: 10%">Booking Reference No</th>
                          <th scope="col" style="width: 10%">INTERMILES Number</th>
                          <th scope="col" style="width: 10%">Airline PNR</th>
                          <th scope="col" style="width: 10%">Booking Date</th>
                          <th scope="col" style="width: 10%">Booking Status</th>
                          <th scope="col" style="width: 10%">Email Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="link" *ngFor="
                            let item of (search_detail_list
                              | paginate: { itemsPerPage: 10, currentPage: p,totalItems:ftr_totalItems })
                          ">
                          <td>{{ item.Booking_Ref }}</td>
  
                          <ng-container *ngIf="ftr_typeOfRedem == 'A'">
                            <td *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                              NA
                            </td>
                            <td *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                              {{ item.JP_NUMBER }}
                            </td>
                          </ng-container>
                          <ng-container *ngIf="ftr_typeOfRedem == 'R'">
                            <td *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                              NA
                            </td>
                            <td *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                              {{ item.JP_NUMBER.slice(2, 11) }}
                            </td>
                          </ng-container>
                          <td *ngIf="item.AIRLINE_PNR != null">{{ item.AIRLINE_PNR }}</td>
                          <td *ngIf="item.AIRLINE_PNR == null">NA</td>
                          <td>{{ item.BOOKING_DATE | date: "dd-MM-yyyy HH:mm:ss" }}</td>
                          <td>{{ item.STATUS_NAME }}</td>
                          <td>{{item.IS_EMAIL_SENT == '1' ? 'Success' : 'Failed'}}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="7">
                            <pagination-controls (pageChange)="pageCount($event)" total-items="ftr_totalItems">
                            </pagination-controls>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list == '' || search_detail_list == 0">
                    <h1 style="text-align:center" *ngIf="ftr_noresult != ''" id="noresulrErr">
                      {{ ftr_noresult }}
                    </h1>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin: 0 auto; text-align: center;">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  

 